import { createParser } from 'nuqs';

type IntegerRange = {
    min: number;
    max?: number;
};

export const createIntegerRangeParser = ({ min, max }: IntegerRange) =>
    createParser({
        parse: (value) => {
            const parsedValue = Number(value);

            if (
                !Number.isInteger(parsedValue) ||
                parsedValue < min ||
                (max !== undefined && parsedValue > max)
            ) {
                return null;
            }

            return parsedValue;
        },
        serialize: String,
    });
